(function(angular) {
    'use strict';

    angular.module('aprima-legacy-common').run(['CustomModuleRunService', customRun]);

    function customRun(CustomModuleRunService) {
        CustomModuleRunService.add([
            'moment',
            momentSetup,
        ]);
    }

    function momentSetup(
        moment
    ) {
        moment.fn.removeOffset = function removeOffset() {
            return this.add(this.utcOffset(), 'minutes').utc();
        };

        // the previous logic was this:
        // moment(date).add(-moment(date).zone(), 'minutes').toDate().toJSON();
        // OR
        // moment(date).add(moment(date).utcOffset(), 'minutes').toDate().toJSON();
        moment.fn.formatRemoveOffset = function formatRemoveOffset() {
            return this.removeOffset().format();
        };


        moment.fn.startOfDate = function() {
            return this.startOf('day').toDate();
        };
    }

})(window.angular);
